"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_TYPE = void 0;
var SERVICE_TYPE;
(function (SERVICE_TYPE) {
    SERVICE_TYPE[SERVICE_TYPE["MAIN"] = 1] = "MAIN";
    SERVICE_TYPE[SERVICE_TYPE["MINOR"] = 2] = "MINOR";
    SERVICE_TYPE[SERVICE_TYPE["HIDDEN"] = 3] = "HIDDEN";
    SERVICE_TYPE[SERVICE_TYPE["INSTANT"] = 4] = "INSTANT";
    SERVICE_TYPE[SERVICE_TYPE["COUNSELLING"] = 5] = "COUNSELLING";
    SERVICE_TYPE[SERVICE_TYPE["FREE_DEMO"] = 6] = "FREE_DEMO";
})(SERVICE_TYPE || (exports.SERVICE_TYPE = SERVICE_TYPE = {}));
